import styled, { css } from 'styled-components';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    Disableable,
    getSpacingToken,
    getTextTokenPreset,
    getToken,
} from '@optimus-web/common';
import { Badge } from '../../Badge';
import { Icon } from '../../Icon';
import { Activable, Inlined } from '../../types';
import { getTabToken, getUnderlineStyles } from './tokens';

export interface TabContainerElementProps extends Activable, Inlined, Disableable {
    hasIcon?: boolean;
    underline?: boolean;
    showDivider?: boolean;
}

export const TabLabelElement = styled.div`
    ${getTextTokenPreset('bodyMediumStrong')}

    text-align: center;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const TabContainerElement = styled.button<TabContainerElementProps>`
    position: relative;
    min-height: ${getToken('sizing600')}px;

    border: none;
    color: ${getTabToken('color')};

    background-color: inherit;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    text-decoration: none;

    ${(props) =>
        !props.inline &&
        css`
            flex: 1;
        `}
    padding: ${(props) => {
        const FINAL_SPACING =
            getSpacingToken('100')({ theme: props.theme }) + getSpacingToken('50')({ theme: props.theme });

        return props.inline ? `${FINAL_SPACING}px` : `${FINAL_SPACING}px 0 `;
    }};

    ${getUnderlineStyles}

    ${({ disabled, onClick }) => {
        if (disabled) {
            return css`
                cursor: not-allowed;
            `;
        } else if (onClick) {
            return css`
                cursor: pointer;
            `;
        }
    }}

    &:hover {
        color: ${(props) => (props.onClick ? getTabToken('color', 'hover') : undefined)};
    }

    &:active {
        outline: none;
        color: ${getTabToken('color', 'active')};
    }

    &:focus-visible {
        outline: none;
        box-shadow:
            inset 0px 0px 0px 2px ${getToken('backgroundStaticFlat')},
            inset 0px 0px 0px 4px ${getToken('borderInteractiveFocus')};
        border-radius: ${getToken('borderRadius0')}px;
        z-index: 9;
    }

    transition: color ${ANIMATION_DURATION.fast}ms ${ANIMATION_CURVE.default};
`;

export const BadgeElement = styled(Badge)<Disableable>`
    margin-left: ${getSpacingToken('50')}px;

    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${getToken('backgroundDisabled')};
            color: ${getToken('textDisabled')};
        `}
`;

export const TabIconContainer = styled.div`
    margin-right: ${getSpacingToken('50')}px;
`;

export const IconStyled = styled(Icon)`
    vertical-align: text-bottom;
`;
